import * as queryString from 'query-string';
import React from 'react';
import { Plus } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { TabContent, TabPane } from 'reactstrap';
import { AppLayout, AuthLayout, CustomPrimaryButton, TabLink, TopBar } from '../../../components';
import { Breadcrumb } from '../../../components/breadcrumbs/breadcrumbs';
import { ChangeUserStatusModel, CreateUserModel, EditUserModel } from '../../../models/request';
import { User } from '../../../models/response';
import { ApplicationState } from '../../../store';
import { AirportsThunk } from '../../../store/airports/airports.thunk';
import { UsersThunk } from '../../../store/users/users.thunk';
// import { ClientStatuses } from '../../../util/constants';
import { HeaderStyleWrapper } from '../bookings/view-booking/view-booking-page.style';
import { CreateUserModal } from './modals';
import { EditUserModal } from './modals/edit-user-modal';
import { UsersTable } from './users-table';

export const ManageUsersPage = () => {
    const breadcrumbs: Breadcrumb[] = [
        { name: 'Dashboard', path: '/app/dashboard' },
        { name: 'All Users', path: window.location.href },
    ];

    const [createModalOpen, setCreateModalOpen] = React.useState(false);
    const [EditModalOpen, setEditModalOpen] = React.useState(false);
    const [value, setValue] = React.useState('');
    const [activeUser, setActiveUser] = React.useState<User>();
    const [searchTerm, setSearchTem] = React.useState('');
    const { search } = useLocation();

    const links: TabLink[] = [
        { index: 1, name: 'All Users', query: [] },
        { index: 2, name: 'Suspended', query: ['status', 'false'] },
    ];

    const [activeTab, setActiveTab] = React.useState(1);
    const dispatch = useDispatch();
    const { users, usersMeta } = useSelector((state: ApplicationState) => state.users);

    const pageNumber = React.useMemo(() => +(queryString.parse(search) as any).page || 1, [search]);
    const status: 'true' | 'false' | undefined = React.useMemo(
        () => (queryString.parse(search) as any).status,
        [search]
    );

    const handleCreateUser = React.useCallback(
        (userDetails: CreateUserModel) => {
            dispatch(UsersThunk.createUser(userDetails, setCreateModalOpen.bind(undefined, false)));
        },
        [dispatch]
    );

    const handleUpdateUser = React.useCallback(
        (userDetails: EditUserModel) => {
            dispatch(UsersThunk.UpdateUser(userDetails, setEditModalOpen.bind(undefined, false)));
        },
        [dispatch]
    );

    const handleSetStatus = React.useCallback(
        (user: User, status: boolean) => {
            if (user.account_Status !== status) {
                user.account_Status = status;
                dispatch(UsersThunk.changeUserStatus(new ChangeUserStatusModel(user)));
            }
        },
        [dispatch]
    );

    const fetchUsers = React.useCallback(() => {
        dispatch(UsersThunk.getAllUsers(pageNumber, searchTerm));
    }, [dispatch, pageNumber]);

    React.useEffect(() => {
        fetchUsers();
        dispatch(AirportsThunk.list());

        switch (status) {
            case 'false':
                setActiveTab(2);
                break;
            default:
                setActiveTab(1);
        }
    }, [dispatch, status, fetchUsers]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTem(e.target.value);
    };

    const handleSearch = () => {
        dispatch(UsersThunk.getAllUsers(pageNumber, searchTerm));
    };
    const filterdUsers: User[] = users.filter((user: User) => {
        return (
            (user.firstName && user.firstName.toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
            (user.email && user.email.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1)
        );
    });

    return (
        <AuthLayout showSidebar={false}>
            <TopBar breadcrumbs={breadcrumbs} />

            <CreateUserModal
                isOpen={createModalOpen}
                setIsOpen={setCreateModalOpen}
                handleCreateUser={handleCreateUser}
            />
            {activeUser && (
                <EditUserModal
                    editModalOpen={EditModalOpen}
                    setEditModalOpen={setEditModalOpen}
                    activeUser={activeUser}
                    handleUpdateUser={handleUpdateUser}
                />
            )}

            <AppLayout.Wrapper>
                <AppLayout.Header>
                    <HeaderStyleWrapper>
                        <div className="flex-column" style={{ flex: 1 }}>
                            <h3 className="header__title">All Users</h3>
                            <p>{users?.length} total Users</p>
                        </div>
                        <div className="right d-flex justify-content-end">
                            <CustomPrimaryButton onClick={setCreateModalOpen.bind(undefined, true)}>
                                <Plus size={14} strokeWidth={3} />
                                <span>Add User</span>
                            </CustomPrimaryButton>
                        </div>
                    </HeaderStyleWrapper>
                </AppLayout.Header>
                <AppLayout.Body>
                    <AppLayout.TabHeader
                        links={links}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        handleChange={handleChange}
                        value={searchTerm}
                        handleSearch={handleSearch}
                        searchable
                        isSearchNotOnChange
                    />
                    <AppLayout.TabBody>
                        <TabContent activeTab={activeTab} className="tab__content">
                            <TabPane tabId={1}>
                                {filterdUsers.length ? (
                                    <UsersTable
                                        users={filterdUsers}
                                        meta={usersMeta}
                                        setActiveUser={setActiveUser}
                                        handleSetStatus={handleSetStatus}
                                        handleModal={setEditModalOpen}
                                    />
                                ) : (
                                    <p>There are no users</p>
                                )}
                            </TabPane>
                            <TabPane tabId={2}>
                                {filterdUsers.length ? (
                                    <UsersTable
                                        users={filterdUsers}
                                        meta={usersMeta}
                                        setActiveUser={setActiveUser}
                                        handleSetStatus={handleSetStatus}
                                        handleModal={setEditModalOpen}
                                    />
                                ) : (
                                    <p>There are no users</p>
                                )}
                            </TabPane>
                        </TabContent>
                    </AppLayout.TabBody>
                </AppLayout.Body>
            </AppLayout.Wrapper>
        </AuthLayout>
    );
};
